module.exports = __webpack_public_path__ + "static/media/st-bill-img-pay-done.92969301.svg";